import React, { useState } from "react";
// ANT DESIGN COMPONENTS
import { Button, InputNumber, Tag } from "antd";
// INTERFACES
import { UInt16 } from "../../../interfaces/AdapterCdoModbus.interface";

export default function FormSelectMultipleNumbers({
	inputValue,
	inputOnChange,
	disabledInput,
}: {
	inputValue: UInt16[];
	inputOnChange: (newValue: UInt16[]) => void;
	disabledInput: boolean;
}) {
	// ************************************************ */
	// USE STATE VARIABLES **************************** */
	const [currentValue, setCurrentValue] = useState<number | null>(null);

	// ************************************************ */
	// FUNCTIONS ************************************** */

	const handleAdd = () => {
		if (currentValue == null) return;

		const normalizedValue = Math.max(
			0,
			Math.min(65535, currentValue),
		) as UInt16;
		const newArray = [...inputValue, normalizedValue];
		inputOnChange(newArray);
		setCurrentValue(null);
	};

	const handleRemove = (index: number) => {
		const newArray = inputValue.filter((_, i) => i !== index);
		inputOnChange(newArray);
	};

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div className='col-md-12 mt-3'>
			<div className='generalStyles__flex'>
				<div className='generalStyles__inputFlexNameLarge'>
					<span className='generalStyles__inputFlexRequired'>*</span>
					<span>Data</span>
				</div>

				<div className='generalStyles__width100'>
					<div className='generalStyles__width100' style={{ display: "flex" }}>
						<InputNumber
							style={{ width: "100%" }}
							size='small'
							min={0}
							placeholder='Add number'
							value={currentValue}
							onChange={(value) => {
								setCurrentValue(value);
							}}
							disabled={disabledInput}
						/>
						<Button
							size='small'
							type='primary'
							onClick={handleAdd}
							disabled={disabledInput || currentValue == null}
						>
							Add
						</Button>
					</div>

					<div style={{ marginTop: 8 }}>
						{inputValue.map((val, index) => (
							<Tag
								key={`${val}-${index}`}
								closable={!disabledInput}
								onClose={() => handleRemove(index)}
							>
								{val}
							</Tag>
						))}
					</div>
				</div>

				<div className='generalStyles__infoTooltipIconBlank' />
			</div>
		</div>
	);
}
